import React, { useEffect, useRef, useState } from "react";
import { Dropdown, Tab, ButtonGroup, DropdownButton } from 'react-bootstrap'
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { Link, useLocation } from 'react-router-dom';
import { json } from "stream/consumers";
import clsx from 'clsx';
import { KTIcon,KTSVG,toAbsoluteUrl } from '../../_metronic/helpers';
import { ShowSwalWithConfirmation } from '../../common/SweetAlert';
import CustomPagination from "../../common/Pagination";
import { ShowToast } from "../../common/Toastr";
import fetchAPI from "../../common/fetchAPI";
import Select, { StylesConfig } from 'react-select';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.css';
import { useTranslation } from "react-i18next";
import { formatDateWithDateAndMonthName, formatDateWithTZ, getValueFromResource } from "../../common/timeLiveFunction";
import {
    resetSelectedRecordObjectInState, getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync,
    getCalculateAmountAndReimburseAsync, ShowExpenseSheetStatusAsync, checkedAllEntryState, unCheckedAllEntryState, checkedEntryState,
    unCheckedEntryState, getExpenseSheetTotalAmountAsync, getDataByAccountExpenseEntryIdAsync, deleteAccountExpenseEntryAsync,
    deleteAllSelectedExpenseEntriesAsync, updateAccountExpenseSheetAsync, SubmitExpenseSheetAsync, GetEmployeeExpenseSheetApprovalDetailAsync,
    GetSubmittedByAndSubmittedOnAsync,  getValidateAccountExpensePolicyAsync, updateAccountExpenseEntryId
} from "./expenseSlice";


import moment from "moment";
import CanvasLoader from "../../common/CanvasLoader";
import { UpdateRefreshApi } from "../timesheet/timesheetSlice";
const itemClass = 'ms-1 ms-lg-0';

const ExpenseSheetApprovalDetail = (props: any) => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const { obj } = location.state || {};
    const { t } = useTranslation();
    let AccountEmployeeExpenseSheetId = '';
    const { employeeList, MasterEmployeeExpenseSheetId, AccountEmployeeId, expensesheetDate,
       expenseSheetApprovalList} = useAppSelector((state) => state.expense);
       const { decimalPlaces, cultureInfoName, ProfileTimeZoneIANA } = useAppSelector((state) => state.globalState);
    const {refreshApi} = useAppSelector((state)=> state.timesheet);

    if (MasterEmployeeExpenseSheetId && MasterEmployeeExpenseSheetId !== '') {
        AccountEmployeeExpenseSheetId = MasterEmployeeExpenseSheetId;
    } 
    else
    if (obj && obj.AccountEmployeeExpenseSheetId) {
        AccountEmployeeExpenseSheetId = obj.AccountEmployeeExpenseSheetId;
    }

    const currentDate = new Date();
    const [SelectedDate, setSelectedDate] = useState(currentDate);   
    const [submittedBy, setSubmittedBy] = useState('');
    const [submittedOn, setsubmittedOn] = useState('');
    const [dropdownOpen, setDropdownOpen] = useState(false); 
    const [isCanvasLoader, setIsCanvasLoader] = useState(true);

    useEffect(() => {
        if (refreshApi) {
            dispatch(GetEmployeeExpenseSheetApprovalDetailAsync(AccountEmployeeExpenseSheetId));
            dispatch(GetSubmittedByAndSubmittedOnAsync(AccountEmployeeExpenseSheetId))
                .unwrap()
                .then((originalPromiseResult) => {
                    setSubmittedBy(originalPromiseResult.Data[0].EmployeeName)
                    //const submittedDate = new Date(originalPromiseResult.Data[0].SubmittedDate);
                    const submittedDate = originalPromiseResult.Data[0].SubmittedDate;
                    //const formattedDate: any = submittedDate ? formatDateWithDateAndMonthName(submittedDate, cultureInfoName.toString(), ProfileTimeZoneIANA) : null;
                    //setsubmittedOn(formattedDate);
                    setsubmittedOn(formatDateWithTZ(moment.parseZone(submittedDate).format('YYYY-MM-DD'), cultureInfoName.toString(), ProfileTimeZoneIANA));
                })
                .catch((rejectedValueOrSerializedError) => {
                    console.log('Error Reimburse Calculate Amount', rejectedValueOrSerializedError);
                })
            setIsCanvasLoader(false);
        }
        dispatch(UpdateRefreshApi(false));
    }, [refreshApi])

    useEffect(() => {
        if (AccountEmployeeExpenseSheetId !== ''){
                dispatch(GetEmployeeExpenseSheetApprovalDetailAsync(AccountEmployeeExpenseSheetId));
                dispatch(GetSubmittedByAndSubmittedOnAsync(AccountEmployeeExpenseSheetId))
                    .unwrap()
                    .then((originalPromiseResult) => {
                        setSubmittedBy(originalPromiseResult.Data[0].EmployeeName)
                        //const submittedDate = new Date(originalPromiseResult.Data[0].SubmittedDate);
                        const submittedDate = originalPromiseResult.Data[0].SubmittedDate;
                        //const formattedDate: any = submittedDate ? formatDateWithDateAndMonthName(submittedDate, cultureInfoName.toString(), ProfileTimeZoneIANA) : null;
                        //setsubmittedOn(formattedDate);
                        setsubmittedOn(formatDateWithTZ(moment.parseZone(submittedDate).format('YYYY-MM-DD'), cultureInfoName.toString(), ProfileTimeZoneIANA));
                    })
                    .catch((rejectedValueOrSerializedError) => {
                        console.log('Error Reimburse Calculate Amount', rejectedValueOrSerializedError);
                    })
                    setIsCanvasLoader(false);
        }
    }, [AccountEmployeeExpenseSheetId]);


    const renderApprovalStatus = (approverStatus: any) => {
        let status: any = "";

        if (approverStatus.ApprovalEmployeeName === null) {
            status = (
                <span className="badge badge-light-success fs-7">
                    {/* Approved */}
                    {getValueFromResource('Approved',dispatch, t)}

                </span>

            )
        }
        else if (approverStatus.IsApproved === true) {
            status = (
                <span className="badge badge-light-success fs-7">
                    {/* Approved */}
                    {getValueFromResource('Approved',dispatch, t)}
                </span>
            )
        } else if (approverStatus.IsRejected === true) {
            status = (
                <span className="badge badge-light-danger fs-7">
                    {/* Rejected */}
                    {getValueFromResource('Rejected',dispatch, t)}

                </span>
            )
        }

        return status;
    }
  
    return (
      
        <>
         <div className="modal drawer-overlay" tabIndex={-1} data-bs-backdrop="false" id="expenseSheetApprovalDetails" role="dialog" aria-labelledby="exampleModalSizeSm" aria-hidden="true">
                <div className='modal-dialog modal-xl'>
                    <div className='modal-content rounded'>
                        <div className="modal-header pb-2">
                            <h5>
                                {/* {t('Expense Approval Details')} */}
                                {getValueFromResource('Expense Approval Details',dispatch, t)}

                                </h5>
                            <div
                                className="btn btn-icon btn-sm btn-active-light-primary"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <KTSVG
                                    path="/media/icons/duotune/arrows/arr061.svg"
                                    className="svg-icon svg-icon-2x"
                                />
                            </div>
                        </div>
                <div className='modal-body pt-0 pb-15 px-5 px-xl-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>                            
                {isCanvasLoader ? <CanvasLoader/> : <>
                            <div className="table">
                                <table className="table" >
                                    <thead>
                                        <tr>
                                                <th style={{ textAlign: 'center' }}>
                                                <div className='hdApprovalDetail'>
                                                        <div className='symbol symbol-36px me-2'>
                                                            <img src={toAbsoluteUrl('/media/svg/customSVG/icon-Employee.svg')} />
                                                        </div>
                                                        <div style={{ textAlign: 'left', marginLeft: '6px' }}>
                                                            <div>
                                                                {/* {t('Submitted By')} */}
                                                                {getValueFromResource('Submitted By',dispatch, t)}

                                                                </div>
                                                            <div style={{ fontSize: 14, fontWeight: '600', marginTop: '2px' }}>{submittedBy}</div>
                                                        </div>
                                                    </div>
                                                </th>
                                                <th style={{ textAlign: 'center' }}>
                                                <div className='hdApprovalDetail'>
                                                        <div className='symbol symbol-36px me-2'>
                                                            <img src={toAbsoluteUrl('/media/svg/customSVG/icon-Date.svg')} />
                                                        </div>
                                                        <div style={{ textAlign: 'left', marginLeft: '6px' }}>
                                                            <div>
                                                                {/* {t('Submitted On')} */}
                                                                {getValueFromResource('Submitted On',dispatch, t)}

                                                                </div>
                                                                <div style={{ fontSize: 14, fontWeight: '600', marginTop: '2px' }}>{submittedOn}</div>
                                                            {/* <div style={{ fontSize: 14, fontWeight: '600', marginTop: '2px' }}>{submittedOn}</div> */}
                                                        </div>
                                                    </div>
                                                </th>      
                                        </tr>
                                    </thead>
                                 
                                </table>
                            </div>    
                            <div className="custom-separator"></div>                                                      
                            <div className="table-responsive">
                                <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                                        <thead>
                                            <tr className="tbheading align-middle">
                                                <th className='w-35' style={{ paddingLeft: '10px' }}>
                                                    {/* {t(`Approver Name`)} */}
                                                    {getValueFromResource('Approver Name', dispatch, t)}
                                                    </th>
                                                <th className='w-10'>
                                                    {/* {t('Approved On')} */}
                                                    {getValueFromResource('Approved On', dispatch, t)}

                                                </th>
                                                <th className='w-10'>
                                                    {/* {t('Status')} */}
                                                    {getValueFromResource('Status', dispatch, t)}

                                                </th>
                                                <th className='w-25'>
                                                    {/* {t('Comments')} */}
                                                    {getValueFromResource('Comments', dispatch, t)}

                                                </th>
                                                <th className='w-20'>
                                                    {/* {t('Projects')} */}
                                                    {getValueFromResource('Projects', dispatch, t)}

                                                </th>
                                            </tr>
                                        </thead>
                                    <tbody>
                                        {/* {expenseSheetApprovalList.length === 0 && <tr><td>No Record Found.</td></tr>} */}
                                        {expenseSheetApprovalList.length > 0 && expenseSheetApprovalList.map((expenseApprovalDetail: any, i: any) => (
                                             <tr key={i}  style={{ height:42 }}>
                                                <td  style={{paddingLeft: '10px'}}>
                                                    {expenseApprovalDetail.ApprovalEmployeeName !== null ? expenseApprovalDetail.ApprovalEmployeeName +' - '+ expenseApprovalDetail.SystemApproverType : 'System'}
                                                </td>
                                                <td>
                                                    {expenseApprovalDetail.ApprovedOn !== null ? formatDateWithDateAndMonthName(expenseApprovalDetail.ApprovedOn, cultureInfoName.toString()) : formatDateWithDateAndMonthName(expenseApprovalDetail.SubmittedDate, cultureInfoName.toString())}
                                                    {/* {expenseApprovalDetail.ApprovedOn !== null ? formatDateWithTZ(moment.parseZone(expenseApprovalDetail.ApprovedOn).format("YYYY-MM-DD"), cultureInfoName.toString(), ProfileTimeZoneIANA) : formatDateWithTZ(moment.parseZone(expenseApprovalDetail.SubmittedDate).format("YYYY-MM-DD"), cultureInfoName.toString(), ProfileTimeZoneIANA)} */}
                                                    
                                                </td>
                                                <td>
                                                    {renderApprovalStatus(expenseApprovalDetail)}
                                                </td>
                                                <td>
                                                    {expenseApprovalDetail.Comments}
                                                </td>
                                                <td>
                                                    {expenseApprovalDetail.ProjectName}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                    {(expenseSheetApprovalList.length === 0 || expenseSheetApprovalList.length === undefined) &&
                                        <div className=''>
                                            <p className='noDataFound'>
                                                {/* {t('No Record Found')} */}
                                                {getValueFromResource('No Record Found', dispatch, t)}
                                            </p>
                                        </div>}
                            </div>
                            </>
                            }
                        </div>
                        <div className="modal-footer"  >
                        <button
                            type="button"
                            className="btn btn-secondary btn-sm"
                            data-bs-dismiss="modal"
                        >
                            {/* {t('Cancel')} */}
                            {getValueFromResource('Cancel', dispatch, t)}
                        </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}
export default ExpenseSheetApprovalDetail;